module.exports = __webpack_public_path__ + "media/src/images/certificates/frame_green_en-ff2329d3f76de42f4828d0857330f8cd.png";